import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  background: ${color.grey1};
  height: 76px;
  width: 136px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .component_creative_column_image_time {
    background-color: ${color.black1};
    position: absolute;
    left: 4px;
    bottom: 4px;
    padding: 0 2px;
    border-radius: 4px;
    line-height: unset;
    color: ${color.white};
    opacity: 0.75;
  }
`;

export default Wrapper;
